import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [displayText, setDisplayText] = useState('');
  const fullText = 'ENES_TİRYAKİ.exe';
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setDisplayText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, 100);

    return () => clearInterval(typingInterval);
  }, []);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);
    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <header className="cyber-header">
      <div className="matrix-bg"></div>
      <div className="header-container">
        <div className="terminal-window">
          <div className="terminal-header">
            <span className="terminal-dot red"></span>
            <span className="terminal-dot yellow"></span>
            <span className="terminal-dot green"></span>
            <span className="terminal-title">root@localhost:~</span>
          </div>
          <div className="terminal-body">
            <div className="terminal-line">
              <span className="prompt">$</span>
              <span className="command">whoami</span>
            </div>
            <div className="terminal-output">
              <h1 className="glitch-text" data-text={displayText}>
                {displayText}
                {showCursor && <span className="cursor">_</span>}
              </h1>
              <p className="subtitle">
                <span className="bracket">{'<'}</span>
                BILGISAYAR_MÜHENDİSİ
                <span className="bracket">{'/>'}</span>
              </p>
            </div>
            <div className="terminal-line">
              <span className="prompt">$</span>
              <span className="command">cat contact.txt</span>
            </div>
            <div className="contact-grid">
              <a href="mailto:tiryakienes72@gmail.com" className="contact-link">
                <span className="icon">[📧]</span>
                <span className="text">tiryakienes72@gmail.com</span>
              </a>
              <a href="https://www.linkedin.com/in/enes-tiryaki/" target="_blank" rel="noopener noreferrer" className="contact-link">
                <span className="icon">[💼]</span>
                <span className="text">linkedin.com/in/enes-tiryaki</span>
              </a>
            </div>
          </div>
        </div>
        
        <div className="status-bar">
          <span className="status-item">STATUS: <span className="online">ONLINE</span></span>
          <span className="status-item">LOCATION: TR/BATMAN</span>
          <span className="status-item">UPTIME: {new Date().getFullYear() - 2022}Y</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
